import { curry } from 'ramda';
export let sep = '/';
export function basename(path) {
    return segments(path).pop() ?? '';
}
export function dirname(path) {
    return sep + segments(path).slice(0, -1).join(sep);
}
export function depth(path) {
    return segments(path).length;
}
export function join(...paths) {
    return normalize(paths
        .reduce((all, path) => [...all, ...segments(path)], [])
        .join(sep));
}
export function normalize(path) {
    return sep + segments(path).join(sep); // TODO '..' etc
}
export function parse(path) {
    const base = basename(path);
    const dot = base.lastIndexOf('.');
    const name = dot > 0 ? base.substring(0, dot) : base;
    const ext = dot > 0 ? base.substring(dot) : '';
    const parts = segments(path);
    return {
        dir: dirname(path),
        root: (path.length && path[0] == sep) ? sep : '',
        top: parts.length ? parts[0] : '',
        base,
        name,
        ext
    };
}
export function segments(path) {
    return path.split(sep).filter(part => part.length);
}
export const descendantOf = curry((ancestor, path) => normalize(path).startsWith(normalize(ancestor)));
export const childOf = curry((parent, path) => path == parent || dirname(path) == parent);
